import { BaseWebComponent } from "../base-components/base-web-component";
import { UISchema } from "@bonusmap/api-types";
export abstract class BaseView extends BaseWebComponent {
    public dataSource!: UISchema; // Placeholder for data source, can be set externally
    constructor() {
        super();
        this.dataSource = window.dataSource;
    }
    protected async buildRenderingData(): Promise<Record<string, any>> {
        // Override in subclasses to provide data for rendering
        return {};
    }
    protected async render(): Promise<void> {
        const data = await this.buildRenderingData();
        this.renderTemplate(this._templateId, data);
        this.afterRender();
    }
} 